import determineTarget from './determine-target';
import toggleElement from './toggle-element';

export default function setupAccordion() {
	document.addEventListener( 'click', event => {
		let toggle = event.target;

		// If not the literal toggle, check if it's a decendent of one
		if ( ! toggle.classList.contains( 'js-accordion-toggle' ) ) {
			toggle = toggle.closest( '.js-accordion-toggle' );
		}

		// No match, ignore event
		if ( ! toggle ) {
			return;
		}

		event.preventDefault();

		// Get target, abort if not found
		const content = determineTarget( toggle );
		if ( ! content ) {
			return;
		}

		// Toggle status
		const show = toggle.getAttribute( 'aria-expanded' ) === 'false';

		// Toggle status
		if ( show ) {
			// Animate to "auto" height
			content.style.setProperty( '--open-height', `${ content.scrollHeight }px` );

			// If it's within a group, close all others
			const group = toggle.closest( '.js-accordion-group' );
			if ( group ) {
				group.querySelectorAll( '.js-accordion-toggle[aria-expanded="true"]' )
					.forEach( otherToggle => {
						// Don't change the current toggle
						if ( otherToggle === toggle ) {
							return;
						}

						// Get target content, animate from current height
						const otherContent = determineTarget( otherToggle );
						otherContent.style.setProperty( '--open-height', `${ otherContent.clientHeight }px` );

						// Mark as closed
						toggleElement( otherContent, false );
					} );
			}
		} else {
			// Animate from current height
			content.style.setProperty( '--open-height', `${ content.clientHeight }px` );
		}

		// Mark as open/close
		toggleElement( content, show );
	} );

	// Initialize accordion expanded states
	document.querySelectorAll( '.js-accordion-toggle' )
		.forEach( toggle => {
			// Mark as open/closed based on auto-open class
			toggleElement( determineTarget( toggle ), toggle.classList.contains( 'auto-open' ) );
		} );
}
